import { render } from "./CustomersLogin.vue?vue&type=template&id=6725f2bc"
import script from "./CustomersLogin.vue?vue&type=script&lang=js"
export * from "./CustomersLogin.vue?vue&type=script&lang=js"

import exportComponent from "/Users/raul.sanchez/Dropbox/___Proyectos.2021/auth.ges.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__